import { Skeleton } from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import SmallForm from './small-form';
import Button from '../base/button';
import Text from '../base/text';

import Arranger from '~c/components/base/arranger';
import Spacer, { spc } from '~c/components/base/spacer';
import { nodeAuthApi } from '~c/services';

interface Props {
  className?: string;
}

const UserAccountActivationImpl: React.FC<Props> = ({ className }) => {
  const navigate = useNavigate();
  const { code } = useParams();
  const [messages, setMessages] = React.useState<string>('');

  const [sendUserActivation, { isLoading }] =
    nodeAuthApi.useAccountActivationMutation();

  const activateUser = async () => {
    await sendUserActivation({
      activationId: code ?? '',
      activationType: true,
    })
      .then((resp: any) => {
        if ('data' in resp && !('error' in resp?.data)) {
          setMessages(
            `You have successfully approved the user create account request for ${resp.data.email}`
          );
        } else {
          setMessages(resp.error.data.error);
        }
      })
      .catch(() => {
        // handle error
      });
  };

  const handleSignInRedirect = () => {
    navigate('/sign-in');
  };

  React.useEffect(() => {
    activateUser();
  }, []);

  if (isLoading) {
    return (
      <SmallForm className={className}>
        <Arranger
          direction="column"
          alignItems="center"
          sx={{ pt: spc.between_vertical_l, pb: spc.between_vertical_l }}
        >
          {/* Logo skeleton */}
          <Arranger
            direction="column"
            alignItems="center"
            sx={{ pb: spc.between_vertical_m }}
          >
            <Skeleton variant="rectangular" width={120} height={36} />
          </Arranger>

          {/* Message skeleton */}
          <Skeleton variant="text" width="80%" height={32} />
          <Spacer pb={spc.xs} />
          <Skeleton variant="text" width="60%" height={24} />

          <Spacer pb={spc.m} />

          {/* Button skeleton */}
          <Skeleton variant="rounded" width={140} height={48} />
        </Arranger>
      </SmallForm>
    );
  }

  // Show custom UI with button for both success and error cases
  return (
    <>
      {messages && (
        <SmallForm className={className}>
          <Arranger
            direction="column"
            alignItems="center"
            sx={{ pt: spc.between_vertical_l, pb: spc.between_vertical_l }}
          >
            <Arranger
              direction="column"
              alignItems="center"
              sx={{ pb: spc.between_vertical_m }}
            >
              <img
                src="/images/new-logo-fairly-light.png"
                height={36}
                alt="Fairly Logo"
              />
            </Arranger>
            <Text sz="title" align="center">
              {messages}
            </Text>
            <Spacer pb={spc.m} />
            <Button onClick={handleSignInRedirect}>Go to Sign In</Button>
          </Arranger>
        </SmallForm>
      )}
    </>
  );
};

export const UserAccountActivation = muiStyled(UserAccountActivationImpl)(
  ({ theme }) => css``
);

export default UserAccountActivation;
